import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';

const links = [
  { label: 'Journey', href: '#how' },
  { label: 'Included', href: '#included' },
  { label: 'Destinations', href: '#discover' },
  { label: 'FAQ', href: '#faq' },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? 'backdrop-blur-md shadow-[0_1px_0_0_rgba(184,147,74,0.15)]' : ''
      }`}
      style={scrolled ? { background: 'rgba(251,247,238,0.95)' } : { background: 'transparent' }}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-5 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-3 leading-none">
          <img
            src="/images/logo/KE-Gold.png"
            alt="Karma Experience"
            className="h-9 md:h-10 w-auto object-contain"
          />
        </a>

        <nav className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="link-underline text-navy text-[0.82rem] tracking-[0.12em] uppercase font-medium"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:block">
          <a href="/activate" className="btn-primary inline-block">Activate Voucher</a>
        </div>

        <button
          className="md:hidden text-navy p-2"
          onClick={() => setOpen(true)}
          aria-label="Open menu"
        >
          <Menu size={22} />
        </button>
      </div>

      {/* Mobile sheet */}
      {open && (
        <div className="fixed inset-0 z-[60] bg-warm flex flex-col">
          <div className="flex items-center justify-between px-6 py-5">
            <img src="/images/logo/KE-Gold.png" alt="Karma Experience" className="h-8 w-auto object-contain" />
            <button onClick={() => setOpen(false)} aria-label="Close menu" className="text-navy p-2">
              <X size={22} />
            </button>
          </div>
          <div className="flex-1 flex flex-col items-center justify-center gap-8">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="font-serif-display text-navy text-3xl"
              >
                {l.label}
              </a>
            ))}
            <a
              href="/activate"
              onClick={() => setOpen(false)}
              className="btn-primary mt-6"
            >
              Activate Voucher
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
